module.exports = __webpack_public_path__ + "static/bend-not-break-9de0e26e0a0f26755012bb7e48d69a91.jpg";